import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify, {
  theme: {
    primary: '#01579B',
    primarylighten: '#5588d2',
    secondary: '#607d8b',
    accent: '#5c8cdb',
    error: '#f44336',
    warning: '#ff8b41',
    info: '#80b9d4',
    success: '#4caf50',
  },
  iconfont: 'md',
});
